import {Component, inject, Input} from '@angular/core';
import {SearchExecutorService} from '../../search-executor.service';
import {SearchContainer} from '../../../core/definitions/search-container';

@Component({
    selector: 'app-search-menu-toggle-restrictions',
    templateUrl: './search-menu-toggle-restrictions.component.html',
    styleUrls: ['./search-menu-toggle-restrictions.component.scss'],
    standalone: false
})
export class SearchMenuToggleRestrictionsComponent {
  // Injections
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);

  @Input() searchContainer: SearchContainer;

  runSearch() {
    this.searchExecutorService.runSearch(this.searchContainer).then();
  }
}
